import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Drawer from "../vapor/drawer";
import UserSettings from "./user-settings";
import "./style.css";
import { useIntl } from "react-intl";
import locale_es from "antd/es/locale/es_ES";

const { Search } = Input;

const SettingsUsersTable = (props) => {
  const { myType, servicesAgyo, auth, companySelected, companyUuidSelected, accountantUuidSelected, clientIdSelected } = props;

  const [openUsersDrawer, setOpenUsersDrawer] = useState(false);
  const [userUuidSelected, setUserUuidSelected] = useState(null);
  const [userCompleteName, setUserCompleteName] = useState("");
  const [filterTable, setFilterTable] = useState(null);
  const [isUsersContentLoading, setIsUsersContentLoading] = useState(false);
  const [isUsersContentError, setIsUsersContentError] = useState(false);
  const [isManager, setIsManager] = useState(false);

  const usersListRaw = useSelector((state) => state.usersList);
  const company = useSelector((state) => state.company);
  const studio = useSelector((state) => state.studio);
  const user = useSelector((state) => state.user);

  const intl = useIntl();

  useEffect(() => {
    setIsUsersContentLoading(usersListRaw.status.ended === false ? true : false);
    setIsUsersContentError(usersListRaw.status.error ? true : false);
  }, [usersListRaw, companySelected, companyUuidSelected, clientIdSelected]);

  const studioName = studio?.list?.[0].ragioneSociale;
  const contentNotAvailable = isUsersContentLoading || isUsersContentError ? true : false;

  const itemUsers = usersListRaw.itemUsers;
  const managerUsers = usersListRaw.managerUsers;

  let usersList = [];

  if (itemUsers !== undefined && managerUsers !== undefined) {
    usersList = itemUsers.concat(managerUsers).filter((user) => user.manageable === true);
  }

  const ownerObject = usersList.find((user) => user.email === auth.loginAuth.id);

  let owner;
  if (ownerObject !== undefined) {
    owner = ownerObject.email;
  }

  const handleOpenSettingsUser = (email) => {
    const selectedProfile = usersList.find((profile) => {
      return profile.email === email;
    });

    let userUuidSelected = null;
    let completeName = "";

    if (selectedProfile !== undefined) {
      completeName = `${selectedProfile.firstName} ${selectedProfile.lastName}`;
      userUuidSelected = selectedProfile.id;
    }
    setUserCompleteName(completeName);
    setUserUuidSelected(userUuidSelected);
    setOpenUsersDrawer(!openUsersDrawer);
  };

  const handleOpenSettingsUserOnRow = (r) => {
    const completeName = `${r.firstName} ${r.lastName}`;
    const userUuidSelected = r.id;

    setUserCompleteName(completeName);
    setUserUuidSelected(userUuidSelected);
    setOpenUsersDrawer(!openUsersDrawer);
  };

  const columns = [
    {
      title: intl.formatMessage({ id: "generic.lastName" }),
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
    },
    {
      title: intl.formatMessage({ id: "generic.firstName" }),
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      dataIndex: "email",
      key: "id",
      render: (email) => (
        <div onClick={email === owner ? null : () => handleOpenSettingsUser(email)}>
          <FontAwesomeIcon icon={["far", "cog"]} className={email === owner ? "iconStyleDisabled iconStyle" : "iconStyle"} />
        </div>
      ),
    },
  ];

  const ragioneSocialeAzienda =
    company &&
    company.companies?.find((el) => {
      return el.id === clientIdSelected;
    })?.ragioneSociale;

  const content = (
    <UserSettings
      auth={auth}
      companySelected={companySelected}
      companyUuidSelected={companyUuidSelected}
      userUuidSelected={userUuidSelected}
      accountantUuidSelected={accountantUuidSelected}
      clientIdSelected={clientIdSelected}
      setOpenUsersDrawer={setOpenUsersDrawer}
      openUsersDrawer={openUsersDrawer}
      managerUsers={managerUsers}
      itemUsers={itemUsers}
      setIsManager={setIsManager}
      ragioneSocialeAzienda={ragioneSocialeAzienda}
      userCompleteName={userCompleteName}
    />
  );

  const searchInTable = (value) => {
    const filterTable = usersList.filter((o) => Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase())));

    setFilterTable(filterTable);
  };

  return (
    <>
      {contentNotAvailable ? (
        <div className="loaderContainer">
          <FontAwesomeIcon icon={["far", "circle-notch"]} spin style={{ color: "rgb(70, 165, 219)", fontSize: "50px" }} />
        </div>
      ) : (
        <>
          <Search
            style={{ margin: "0 0 40px 0" }}
            placeholder={intl.formatMessage({ id: "settings.searchPlaceholder" })}
            enterButton
            onSearch={searchInTable}
          />
          <Table
            dataSource={filterTable == null ? usersList : filterTable}
            columns={columns}
            rowKey="id"
            showSorterTooltip={false}
            locale={user?.profile?.language === "es-ES" ? locale_es : null}
            onRow={(r) => ({
              onClick: () => (r.email === owner ? null : handleOpenSettingsUserOnRow(r)),
            })}
          />
          {openUsersDrawer && (
            <Drawer
              onClose={handleOpenSettingsUser}
              myType={myType}
              servicesAgyo={servicesAgyo}
              headerTitle={userCompleteName}
              headerSubTitle={
                <>
                  di <b className="boldText">{isManager ? studioName : ragioneSocialeAzienda}</b>
                </>
              }
              content={content}
              className="usersDrawer"
            />
          )}
        </>
      )}
    </>
  );
};

export default SettingsUsersTable;
